import { render } from "./attachment-list.vue?vue&type=template&id=490e49c1"
import script from "./attachment-list.vue?vue&type=script&lang=js"
export * from "./attachment-list.vue?vue&type=script&lang=js"

import "./attachment-list.vue?vue&type=style&index=0&id=490e49c1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__